<template>
  <div>


    <div
      class="image-container"
      :style="{'background-image': `url(${getImage(item)})`}"
    >

      <div
        class="image-description"
        v-if="item.type == 'restaurant'"
      >
        <!-- offers is plural, but it's not an array -->
        <span class="image-label">{{ item.offers.name }}</span>
        <span class="image-label">{{ availableDays }}</span>
      </div>

      <div
        class="image-description cinema"
        v-if="item.type == 'cinema'"
      >
        <!-- this is hardcoded, because it's not in the dataset -->
        <span class="image-label">up to 40% off</span>
        <span class="image-label">Mon - Sun</span>
      </div>
    </div>



    <div :class="['description-container', item.type]">
      <div class="description-text">
        <div class="description-top">
          <div class="description-town overflow-ellipsis">{{ town }}</div>
        </div>

        <h2
          class="description-name overflow-ellipsis"
          :title="item.name"
        >{{ item.name }}</h2>
        <div
          class="description-cuisine overflow-ellipsis"
          :title="(item.cuisine || []).join(', ')"
        >
          {{ (item.cuisine || []).join(', ') }}
        </div>



        <div class="description-pivot">
          <div
            v-if="distance"
            class="description-distance"
          >{{distance}} mi</div>
          <div
            class="description-booking-required"
            v-if="item.is_booking_required"
          >Call in advance</div>
        </div>
      </div>




      <div
        class="description-icons"
        v-if="item.type == 'restaurant'"
      >
        <div
          v-for="({icon, iconText, iconTextMeta}, i) in icons"
          :class="`description-icon description-${icon}`"
          :key="i"
        >
          <span class="description-icon-text">{{ iconText }}</span>
          <span
            class="description-icon-text-meta"
            v-if="iconTextMeta"
          >{{ iconTextMeta }}</span>
        </div>
      </div>




      <div
        class="description-icons"
        v-if="item.type == 'cinema'"
      >
        <div class="description-icon description-choose-venue">Choose cinema</div>
        <div class="description-icon description-e-codes">Purchase e‑codes</div>
        <div class="description-icon description-redeem-online">Redeem</div>
      </div>



    </div>

    <a v-if="item.type == 'cinema' && isAuth == false"
      href=""
      @click.prevent="modalTriggered('user_login_required')"
    >&nbsp;</a>

    <a v-else-if="item.type == 'cinema' && isAuth == true && isMembershipValid == false"
      href=""
      @click.prevent="modalTriggered('valid_membership_required')"
    >&nbsp;</a>

    <a v-else
      :href="linkRelativeUrl"
      @click="onClick"
    >&nbsp;</a>


  </div>
</template>





<script>
// const meterToYard = distance => distance * 1.094;
const meterToMile = distance => distance / 1609.344;

// lodash.ghetto
const getProperty = (obj, path) =>
  path
    .split('.')
    .reduce(
      (temp, part) => (typeof temp === 'object' ? temp[part] : undefined),
      obj
    );

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    store: {
      type: Object,
      required: true,
    },
    insights: {
      type: Function,
      required: true,
    },
  },
  computed: {
    isAuth() {
      //console.log('user_type in isAuth' + window.user_type);
      if (window.user_type && (window.user_type == 'gourmetsociety_plus' || window.user_type == 'gourmetsociety_b2b' || window.user_type == 'gourmetsociety_eb')){
        return true;
      }
      else {
        return false;
      }
    },
    isMembershipValid() {
      //console.log('membership_status in isMembershipValid' + window.membership_status);
      if (window.membership_status && window.membership_status == 'valid'){
        return true;
      }
      else {
        return false;
      }
    },
    distance() {
      if (this.item._rankingInfo && this.item._rankingInfo.matchedGeoLocation) {
        return meterToMile(
          this.item._rankingInfo.matchedGeoLocation.distance
        ).toFixed(2);
      }
      return undefined;
    },
    linkAbsoluteUrl(){
      var _linkUrl = this.item.link;
      var pattern = /^((http|https|ftp):\/\/)/;
      if(!pattern.test(_linkUrl)) {
          _linkUrl = `https://www.gourmetsociety.co.uk${_linkUrl}`;
      }
      return _linkUrl;
    },
    linkRelativeUrl(){
      var _linkUrl = this.item.link;
      var pattern = /^((http|https|ftp):\/\/)/;
      if(pattern.test(_linkUrl)) {
        var parser = document.createElement('a');
        parser.href = _linkUrl;
        parser.protocol = window.location.protocol;
        parser.hostname = window.location.hostname;
        parser.port = window.location.port;
        //parser.pathname; // => "/pathname/"
        //parser.search;   // => "?search=test"
        //parser.hash;     // => "#hash"
        //parser.host;     // => "example.com:3000"
          _linkUrl = parser.href;
      }
      return _linkUrl;
    },
    availableDays() {
      const englishOrderDays = {
        Sunday: 1,
        Monday: 2,
        Tuesday: 3,
        Wednesday: 4,
        Thursday: 5,
        Friday: 6,
        Saturday: 7,
      };

      const days = (this.item.availability.available_day || []).filter(
        day => day !== 'December'
      );

      days.sort((a, b) => {
        return englishOrderDays[a] - englishOrderDays[b];
      });

      const firstDay = days[0].slice(0, 3).toUpperCase();
      const lastDay = days[days.length - 1].slice(0, 3).toUpperCase();

      return firstDay + '-' + lastDay;
    },
    icons() {
      const maxDiners = this.item.max_diners;
      const availability =
        (this.item.availability && this.item.availability.available_day) || [];

      let icons = [
        {
          value: item => getProperty(item, 'availability.friday.day') === false,
          iconText: 'FRI',
          icon: 'day-false',
        },
        {
          value: item =>
            getProperty(item, 'availability.saturday.day') === false,
          iconText: 'SAT',
          icon: 'day-false',
        },
        {
          value: item =>
            getProperty(item, 'availability.friday.evening') === false,
          iconText: 'FRI',
          iconTextMeta: 'PM',
          icon: 'day-false',
        },
        {
          value: item =>
            getProperty(item, 'availability.saturday.evening') === false,
          iconText: 'SAT',
          iconTextMeta: 'PM',
          icon: 'day-false',
        },

        {
          value: item => getProperty(item, 'availability.friday.day') === true,
          iconText: 'FRI',
          icon: 'day-true',
        },
        {
          value: item =>
            getProperty(item, 'availability.saturday.day') === true,
          iconText: 'SAT',
          icon: 'day-true',
        },
        {
          value: item =>
            getProperty(item, 'availability.friday.evening') === true,
          iconText: 'FRI',
          iconTextMeta: 'PM',
          icon: 'day-true',
        },
        {
          value: item =>
            getProperty(item, 'availability.saturday.evening') === true,
          iconText: 'SAT',
          iconTextMeta: 'PM',
          icon: 'day-true',
        },
      ].filter(icon => icon.value(this.item));

      // max needs to be first, if present
      if (maxDiners) {
        icons.unshift({ iconText: maxDiners, icon: 'max' });
      }

      // show max 3 regular icons
      icons = icons.slice(0, 3);

      if (this.store.showDecember) {
        // dec needs to be last
        if (availability.indexOf('December') === -1) {
          icons.push({ icon: 'day-false', iconText: 'DEC' });
        } else {
          icons.push({ icon: 'day-true', iconText: 'DEC' });
        }
      }

      return icons;
    },
    town() {
      if (this.item.contact.address.town) {
        return this.item.contact.address.town;
      }

      return [
        ['building', 'street']
          .map(x =>
            this.item && this.item.contact && this.item.contact.address
              ? this.item.contact.address[x]
              : undefined
          )
          .filter(Boolean)
          .join(' '),
        this.item.contact &&
          this.item.contact.address &&
          this.item.contact.address.town,
        this.item.contact &&
          this.item.contact.address &&
          this.item.contact.address.postcode,
      ]
        .filter(Boolean)
        .join(', ');
    },
  },
  methods: {
    onClick() {
      this.insights('clickedObjectIDsAfterSearch', {
        eventName: 'Product Clicked',
        objectIDs: [this.item.objectID],
      });
    },
    getImage(item) {
      if (!item || !item.image) {
        return '';
      }
      if (item.image.indexOf(';') > -1) {
        // if we have semicolons in the image, then it's a multi-image link,
        // so we need to fix it
        return (
          // everything up until the last slash
          item.image.slice(0, item.image.lastIndexOf('/') + 1) +
          // and then from the last semicolon
          item.image.slice(item.image.lastIndexOf(';') + 1, item.image.length)
        );
      }
      return item.image;
    },
    modalTriggered(modalType) {
      // console.log('modal button was pressed');
      // console.log('passed modalType: ' + modalType);
      this.$emit('modalInterface',modalType);
    },
  },
};
</script>

<style lang="scss" scoped>
.overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item {
  display: flex;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  a {
    color: inherit;
    text-decoration: none;
  }
  &-map {
    min-width: 500px;
  }
  &-list,
  &-map {
    height: 162px;
    .description-pivot {
      justify-content: left;
      margin-left: 0;
      margin-right: 0;
    }
    .image {
      &-container {
        width: 45%;
      }
    }
    .description {
      &-container {
        width: 55%;
      }
      &-icon {
        font-size: 8px;
      }
      &-max {
        width: 31px;
        height: 26px;
        padding-top: 2px;
        text-indent: 18px;
      }
      &-day-false,
      &-day-true {
        width: 28px;
        height: 28px;
        padding-top: 6px;
      }
      &-booking-required {
        height: unset;
        margin-top: 3px;
        margin-bottom: 5px;
        &::before {
          height: 15px;
          width: 14px;
        }
      }
    }
  }
  &-grid {
    flex-direction: column;
    .image {
      &-container {
        height: 160px;
        flex-grow: 0;
        flex-shrink: 0;
      }
    }
    .description {
      &-container {
        height: 100%;
      }
      &-text {
        text-align: center;
      }
      &-top {
        margin-bottom: 0;
      }
      &-town {
        width: 100%;
        margin-bottom: 4px;
        font-size: 10px;
      }
      &-name {
        margin-bottom: 4px;
        font-size: 20px;
        @media (max-width: $tablet) {
          font-size: 16px;
        }
      }
      &-cuisine {
        margin-bottom: 12px;
      }
      &-distance {
        justify-content: center;
      }
      &-icons {
        margin: -15px;
        margin-top: 5px;
        padding: 8px;
        background-color: $gallery-grey;
      }
      &-icon {
        font-size: 10px;

        @media (max-width: 450px) {
          transform: scale(0.8);
          transform-origin: center;
        }
      }
      &-icon-text {
        white-space: pre;
      }
      &-max {
        width: 36px;
        height: 29px;
        padding-top: 2px;
        text-indent: 20px;
      }
      &-day {
        width: 27px;
        height: 28px;
        padding-top: 11px;
      }
    }
  }
}

.item {
  position:relative;
}

.item > a {
  position:absolute;
  opacity:0.5;
  top:0px;
  left:0px;
  width: 100%;
  height: 100%;
  cursor:pointer;
}

.image {
  &-container {
    position: relative;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    flex-grow: 0;
    flex-shrink: 0;
  }
  &-description {
    position: absolute;
    bottom: 0;
    display: flex;
    @include theme-value(background, brand-color-two);
    color: $white;
    width: 100%;
    margin: 0;
    padding: 3px 8px;
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    justify-content: space-between;
    flex-grow: 0;
    flex-shrink: 0;
    &.cinema {
      @include theme-value(background, brand-color-three);
    }
  }
  &-label {
    margin: 5px 0;
  }
}

.description {
  &-container {
    display: flex;
    min-width: 0;
    padding: 15px;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;

    .tastecard & {
      background: url('~@/assets/icons/wave.png');
      background-color: white;
      background-size: contain;
      background-position: bottom left;
      background-repeat: no-repeat;
    }
    .gourmet-society & {
      background: none;
    }
    .gourmet-society &.cinema {
      background: none;
    }
  }
  &-name {
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 10px;
    line-height: 28px;

    @media (min-width: $desktop) {
      font-size: 24px;
    }
  }
  &-top {
    display: flex;
    margin: 0 -5px 10px;
    justify-content: space-between;
  }
  &-town {
    margin: 0 5px;
    font-size: 12px;
    text-transform: uppercase;
    opacity: 0.7;
  }
  &-distance {
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    margin: {
      top: 5px;
      bottom: 5px;
      right: 10px;
      left: 0;
    }

    &:before {
      display: block;
      width: 1em;
      height: 1em;
      margin-right: 5px;
      background-image: url('~@/assets/icons/location.png');
      background-repeat: no-repeat;
      background-size: contain;
      content: '';
    }
    &-distance-list {
      margin: 0 5px;
    }
  }
  &-cuisine {
    font-size: 12px;
    text-transform: uppercase;
    opacity: 0.8;
  }
  &-icons {
    display: flex;
    justify-content: center;
    margin: -15px;
    padding: 10px;
    background-color: $gallery-grey;

    .item-list &,
    .item-map & {
      justify-content: flex-start;
    }

    .cinema & {
      padding-bottom: 16px;
    }
  }
  &-icon {
    display: block;
    margin: 0 6px;
    flex-grow: 0;
    flex-shrink: 0;
    background-repeat: no-repeat;
    background-size: contain;
    font-weight: 600;
    font-size: 8px;
  }
  &-icon-text-meta {
    font-size: 7px;
    margin-left: -5px;
  }
  &-max {
    width: 45px;
    height: 36px;
    padding-top: 4px;
    background-image: url('~@/assets/icons/max-diners.svg?external');
    text-indent: 29px;
  }
  &-day-false,
  &-day-true {
    width: 36px;
    height: 32px;
    margin-bottom: -8px;
    padding-top: 8px;
    text-align: center;
    text-indent: -4px;
    display: flex;
    flex-direction: column;
  }
  &-day-false {
    background-image: url('~@/assets/icons/calendar-cross.svg?external');
  }
  &-day-true {
    background-image: url('~@/assets/icons/calendar-check.svg?external');
  }
  &-booking-required {
    text-align: left;
    height: 2em;
    line-height: calc(2em + 1px);
    font-weight: 500;
    font-size: 0.8em;
    position: relative;
    padding-left: 1.6em;
    white-space: pre;
    text-overflow: ellipsis;

    &:before {
      display: inline-block;
      height: 2em;
      width: 2em;
      margin-right: 4px;
      background-image: url('~@/assets/icons/phone.svg?external');
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      left: 0;
      content: '';
    }
  }
  //cinema-specific
  &-choose-venue,
  &-e-codes,
  &-redeem-online {
    flex: 1;
    height: 22px;
    max-width: 6em;
    padding-top: 22px;
    margin-bottom: 10px;
    background-position: top;
    text-align: center;
    background-size: contain;

    .list & {
      flex: 0;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  &-choose-venue {
    background-image: url('~@/assets/location-pin.png');
  }
  &-e-codes {
    background-image: url('~@/assets/icons/cinema-purchase.svg?external');
  }
  &-redeem-online {
    background-image: url('~@/assets/icons/cinema-redeem.svg?external');
  }
}

.description-pivot {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: {
    left: -1em;
    right: -1em;
  }

  .list & {
    margin: 0;
    margin-top: 0.2em;
    flex-direction: row;
  }

  @media (max-width: 470px) {
    font-size: 11px;
  }
}
</style>
